/**
 * Created by eliana.centamore on 08/02/2017.
 */

"use strict";
require("Pages/sepaio.css");
require("Base/init");
var App = require("CommonClientServer/Base/app");
var Base = require("Base/init");
var IbanValidator = require("./IbanValidator");

App.extend({
        init: function (method, model, options) {
            _.extend(this, Base);
            this.ibanValidator = new IbanValidator();
            $('#tab__sepa_bic_from_iban [data-toggle="tooltip"], .sepaio-logo').tooltip();
        }
    })
    .init();
